import React, {
  Children,
  cloneElement,
  forwardRef,
  isValidElement,
  useEffect,
  useImperativeHandle,
} from "react";
import { useRemember } from "@inertiajs/inertia-react";

export const Tabs = forwardRef(
  (
    {
      items = [],
      onTabChange = null,
      actionText = null,
      actionOnClick = null,
      className = "",
      children,
      current = 0,
    },
    ref,
  ) => {
    const [tab, setTab] = useRemember(current, "Tabs/Index");

    useEffect(() => {
      onTabChange && onTabChange(tab);
    }, [tab]);

    useImperativeHandle(
      ref,
      () => ({
        setTabIndex(index) {
          setTab(index);
        },
        getTabIndex() {
          return Number(tab);
        },
      }),
      [tab],
    );

    const childrenWithProps = Children.map(children, (child, index) => {
      if (isValidElement(child)) {
        return cloneElement(child, { tab, setTab, index });
      }
      return child;
    });

    return (
      <>
        <div
          className={`mb-4 flex w-full flex-row border-b border-solid border-gray-400 ${className}`}
        >
          {items.map((t, i) => (
            <span
              key={`tab-${i}`}
              className={`${i === tab ? "border-b-4 text-blue" : "text-typo-inactive"} mr-2 cursor-pointer border-solid border-blue p-4 text-sm uppercase tracking-wide first-line:font-bold`}
              onClick={() => setTab(i)}
            >
              {t}
            </span>
          ))}

          {actionText && actionOnClick ? (
            <span className="flex-grow p-4 text-right">
              <button
                className="text-blue underline hover:no-underline"
                onClick={actionOnClick}
              >
                {actionText}
              </button>
            </span>
          ) : null}
        </div>

        {childrenWithProps}
      </>
    );
  },
);
